import DifyOrderDTO from './DifyOrderDTO';
import { getLocalizedText } from '@vp-dst/localization-util';

export default class CoDesignOrderDTO extends DifyOrderDTO {
    constructor({ productName, productPfid, productConfigurations, note, uploads, uploadRefs, name, email, phone, appointmentDateTimeString, timezone, difyServiceQuantity, calendarId }) {
        super({
            productName,
            productPfid,
            productConfigurations,
            note,
            uploads,
            uploadRefs,
            difyServiceQuantity,
        });

        this.CalendarId = calendarId;
        this.AppointmentTimezoneString = timezone;
        this.AppointmentDateTimeString = appointmentDateTimeString;

        this.Brief = {
            ...this.Brief,
            FirstName: name,
            Phone: phone,
            Email: email,
        };
        
        this.validate = this.validate.bind(this);
    }

    validate() {
        if (!this.SelectedProduct || !this.SelectedProduct.Name) {
            return getLocalizedText('please-select-a-product-before-continuing');
        }
    
        const brief = this.Brief;
        if (!brief.Notes || brief.Notes.length === 0) {
            return getLocalizedText('please-describe-your-design-idea');
        }

        if (!brief.FirstName) {
            return getLocalizedText('please-add-your-name-before-continuing');
        }

        if (!brief.Email) {
            return getLocalizedText('please-add-your-email-address-before-continuing');
        }

        if (!brief.AppointmentDateTimeString) {
            return getLocalizedText('please-select-a-time-for-your-appointment-before-continuing');
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/designServices/dtos/CoDesignOrderDTO.js